import { createAction, props } from '@ngrx/store';
import { Theme } from '../models/theme.model';

// Sets the flavour for the current theme
export const selectTheme = createAction(
    '[UX] Change Theme',
    props<{ theme: Theme }>()
);
